module.exports = __webpack_public_path__ + "static/img/img-4.523d28e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Main/img-4.png
// module id = THUB
// module chunks = 10